module.exports = function() {
  return new Worker(__webpack_public_path__ + "be329234012a69062c4c.worker.js");
};